import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import {Link, withRouter} from 'react-router-dom';

import {encrypt} from './storage';
import { validatePin, validatePassPhrase, validatePhraseLength, validateUsername , validateAddress, validatePassPhrase2} from '../common/validators';
import { QrPassphraseField } from '../common/passphrasefield';
import {FaCheckCircle, FaTimesCircle} from 'react-icons/fa';

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";


class ClaimVoucher_ extends Component {
  constructor(props) {
    super(props);
    this.state={
      name:"",
      nameStatus:{invalid:false,error:""},
      accountRs:"",
      accountRsStatus:{invalid:false,error:""},
      passPhrase:"",
      passPhraseStatus:{invalid:false,error:""},
      usePin:true,
      Pin:"",
      PinStatus:{invalid:false,error:""},
      generateStatus:{invalid:false,error:""},
      hidden: true,
      formValid:false      
    }
    this.toggleShow = this.toggleShow.bind(this);
    this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
  }

  toggleShow() {
    this.setState({ hidden: !this.state.hidden });
  }

  onClick = () => {
    let status = validatePassPhrase(this.state.passPhrase,this.state.passPhraseStatus, this.state.accountRs);
    let nameStatus = validateUsername(this.state.name,this.state.nameStatus,this.props.userList);
    console.log(nameStatus);
    if (status.invalid | nameStatus.invalid) {
      this.setState({passPhraseStatus:status,nameStatus:nameStatus});
    }
    else {
      let user = { 
        name:this.state.name, 
        accountRs:this.state.accountRs,
        usePin:this.state.usePin,
        token: (this.state.usePin && this.state.passPhrase && this.state.Pin) 
                    ? encrypt(this.state.passPhrase,this.state.Pin) : ""
      } 
      this.props.registerNewUser(user);
      this.props.history.push("/login");
    }
  }

  handlePassphraseChange = (e)=>{
    console.log(e);
    var self = this;
    let status = validatePassPhrase2(e);
    self.setState({passPhrase:e,accountRs:status.account},()=>{
      self.setState({
      passPhraseStatus:validatePhraseLength(e,self.state.passPhraseStatus)},
      self.validateForm)
    })}


  handleAccountChange = (e) => {
    console.log(e);
    var self = this;
    let value = e;
    this.setState({accountRs:value}, () => {
      self.setState({
          accountRsStatus:validateAddress(value,self.state.accountRsStatus)},
          self.validateForm)
    
  })}

  validateForm(){
    const nameValid = !this.state.nameStatus.invalid;
    const PinValid = this.state.usePin ? !this.state.PinStatus.invalid : true;
    const passPhraseValid = !this.state.passPhraseStatus.invalid;
    this.setState({formValid:PinValid & passPhraseValid & nameValid});
  }
  
  render() {
    var self = this;

    const notScanned = (<Typography variant="body1"><FaTimesCircle style={{color:'red'}} /> &nbsp; Please scan your QR code to continue</Typography>);
    const scanned = (<Typography variant="body1"><FaCheckCircle style={{color:'green'}}/> &nbsp; Successful, now enter your name to join</Typography>)
    let output = null;
    if (self.state.passPhraseStatus.invalid === true && self.state.passPhrase === ""){
      output = notScanned;
    }
    else if (self.state.passPhraseStatus.invalid === false && self.state.passPhrase === "") {
      output = notScanned;
    }
    else if (self.state.passPhraseStatus.invalid === false) {
      output = scanned;
    }

    return (
      <div style={{textAlign:"center", display:"inline-block"}}><form>
        <Grid container
            justify="center"
            alignItems="stretch"
            direction="column"
            spacing={24}
          >
            <Grid item>
              <Typography style={{textAlign:"right"}}><Link className="link" to="/login">Back to Login</Link></Typography>
              <Typography>&nbsp;</Typography>
              <Typography variant="h5">Scan the QR code and claim your voucher</Typography>
            </Grid>
              
            <Grid item>
                <FormGroup>
                  <QrPassphraseField value={this.state.passPhrase} status={this.state.passPhraseStatus} onChange={self.handlePassphraseChange}>
                      Your secret phrase
                  </QrPassphraseField>
                </FormGroup>
            </Grid>
            <Grid item>
              <FormGroup>
                <TextField
                  id="outlined-full-width"
                  label="Account"
                  style={{ margin: 8 }}
                  placeholder="Voucher Account"
                  helperText=""
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={this.state.accountRs}
                  error={this.state.accountRsStatus.invalid}
                />
              </FormGroup>
            </Grid>
            <Grid item>
                <FormGroup>
                  {output}
                </FormGroup>
            </Grid>
            <Grid item>
                 <FormGroup>
                 <TextField
                  id="outlined-full-width"
                  label="Name"
                  style={{ margin: 8 }}
                  placeholder="Enter your name"
                  helperText=""
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e)=>{
                    let value = e.target.value;
                    self.setState({name:value}, ()=>{
                      self.setState({nameStatus:validateUsername(value,self.state.nameStatus,self.props.userList)}, 
                      self.validateForm)
                  })}}
                  value={this.state.name}
                  error={this.state.nameStatus.invalid}
                />
                 </FormGroup>
                {
              this.state.usePin ? (
                <Grid item>
                  <TextField 
                    fullWidth
                    id="pin"
                    label="Password"
                    placeholder="Password"
                    value={this.state.Pin}
                    onChange={(e)=>{
                      let value = e.target.value;
                      self.setState(
                        {Pin:value},
                        ()=>{
                          self.setState({PinStatus:validatePin(value,self.state.PinStatus)}, self.validateForm)
                        })}}
                    onChangeText={(password) => this.setState({ password })}
                    type={this.state.hidden ? 'password' : 'text'} 
                    className="numeric-password"
                    InputLabelProps={{
                      type:"tel",
                      shrink: true,
                   
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton aria-label="toggle password visibility"  onClick={this.toggleShow} style={{outline:'none'}}>
                          {this.state.hidden ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    margin="normal"
                    variant="outlined"
                    error={this.state.PinStatus.invalid}
                    autoComplete="off"
                  />    
                </Grid>
                ) : null
            }
                <FormGroup>
                  <Button fullWidth variant="outlined" disabled={!self.state.formValid} onClick={()=>this.onClick()}>
                      Register
                  </Button>
                </FormGroup>
              
          </Grid>
        </Grid>
      </form>
      </div>  
    );
  }
}

export const ClaimVoucher = withRouter(ClaimVoucher_);